import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./app/App";
import "./index.css";
// Registers every icon this app uses locally so <Icon icon="…"> never
// depends on a runtime fetch to Iconify's API — must run before anything
// renders, so import it first.
import "./shared/lib/icon-registry";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
